<template>
  <v-app>
    <router-view />
  </v-app>
</template>
<style>
* {
  font-family: "Poppins", sans-serif !important;
}

.thin_scrollbar {
  scrollbar-width: thin !important; /* Firefox */
  scrollbar-color: lightgray !important;
}

.v-navigation-drawer__content {
  scrollbar-width: thin !important; /* Firefox */
  scrollbar-color: lightgray !important;
}

.cursorPointer {
  cursor: pointer !important;
}
.fontVariant0 {
  font-size: 10px !important;
}
.fontVariant1 {
  font-size: 12px !important;
}

.fontVariant2 {
  font-size: 14px !important;
}

.fontVariant3 {
  font-size: 16px !important;
}

.fontVariant4 {
  font-size: 18px !important;
}
.fontVariant5 {
  font-size: 20px !important;
}

.greyTextNavTitle {
  color: #eef2f6 !important;
}

.field_height .v-field {
  min-height: 12px !important;
  max-height: 33px !important;
  display: flex !important;
  align-items: center !important;
}

.field_label_size.v-input .v-label {
  font-size: 10px !important;
  opacity: 1 !important;
}

.field_font .v-field__input {
  font-size: 12px !important;
}

.radio_buttons_label.v-input .v-label {
  font-size: 12px !important;
  opacity: 1 !important;
}

.radio_buttons_field_font .v-field__input {
  font-size: 12px !important;
}

.hover_SelectedItem:hover {
  background-color: #96bfe9 !important;
}
.v-selection-control .v-label {
  font-size: 14px !important;
}
.hoverVList:hover {
  background-image: linear-gradient(#f6faff, #d5d7dd);
}
.v-messages__message {
  font-size: 10px !important;

  padding: 0px !important;
}
.textTruncate {
  width: 100% !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.disabledCardClass {
  pointer-events: none !important;
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  user-select: none !important;
}
</style>
